export default __webpack_public_path__ + "static/media/drum.music.2d6c264c.mp4";